module.exports = __webpack_public_path__ + "media/images/city/065-bridge-of-the-west-9803de04392f557bb53d8adfb83fd864.svg";